﻿import { BaseWidget } from "../BaseWidget"

export class CheckList extends BaseWidget {
    private lastValue: string[] = [];
    allChecks: NodeListOf<HTMLInputElement>;
    
    afterIndex() {
        this.muRegisterEvent("change");
        this.allChecks = this.container.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
        for (const r of this.allChecks)
            r.addEventListener("change", (ev) => {
                const tar: HTMLInputElement = ev.target as HTMLInputElement;

                const val = tar.getAttribute('mu-bind');
                if (this.lastValue.includes(val)) {
                    const index = this.lastValue.indexOf(val);
                    this.lastValue.splice(index, 1);
                } else {
                    this.lastValue.push(val);
                }

                this.muDispatchEvent("change", this.muFetchData());
        })
    }
    
    override muFetchData(): string[] {
        const results: string[] = [];
        for (const r of this.allChecks) if (r.checked) results.push(r.getAttribute("mu-bind"));
        return results;
    }

    override muBindData(value: string | null): void {
        for (const r of this.allChecks) r.checked = value != null ? value.includes(r.getAttribute("mu-bind")) : false;
    }
}

export class CheckListOther extends BaseWidget {
    updateForm() {
        this.value_change();
    }

    value_change(ev = null) {
        let val = "";
        if (ev !== null) {
            const tar: HTMLInputElement = ev.sender.container.querySelector('input:checked[type="checkbox"][mu-bind="other"]') as HTMLInputElement;

            val = tar ? "other" : "";
        }
        this.muVisible(val === "other", "other");
    }
}